// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"272":"41e3b814","292":"6a3295ad","455":"3abb212a","545":"c4490ad6","840":"9abc88f4","877":"9bac5dbc","890":"226f7f62","895":"aa4e52ba","927":"006852c3","977":"8a75b057"}[chunkId] + ".chunk.js";
};